export const MAX_EMAIL_LENGTH = 254;

/** UX-only check; the server validates the address authoritatively. */
export function isValidEmail(email: string): boolean {
  const trimmed = email.trim();
  return trimmed === '' || /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(trimmed);
}
